import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {BasePanel} from "@/scenes.ui/base-panel";
import Container = Phaser.GameObjects.Container;
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import Image = Phaser.GameObjects.Image;
import Text = Phaser.GameObjects.Text;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export abstract class AbstractStandardPanel extends BasePanel {

    protected xButton!: Image;
    protected okButton!: SquareButton;
    protected title!: Text;
    protected background!: Image;
    protected window!: Image;
    protected onCloseCallback!: () => void;

    constructor(scene: Scene, canvas: HTMLCanvasElement, titleText: string, container?: Container) {
        super(scene, canvas, canvas.width / 2, canvas.height / 2 - 30, container);
        this.setDepth(3001);
        this.preInit();

        const self = this;

        this.background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(this.background, canvas!.width * 2, canvas!.height * 2);
        this.add(this.background);

        this.window = SpriteUtils.addImage(this.scene, 0, 0, this.getWindowKey(), undefined,
            self.getWindowScaleX(), self.getWindowScaleY()).setOrigin(0.5, 0.5);

        this.addDecoration();

        this.xButton = SpriteUtils.addImage(this.scene, this.getXButtonX(), this.getXButtonY(), Keys.ATLAS_PROFILE, Keys.UI_ART_X).setOrigin(0.5, 0.5);

        this.xButton.setInteractive().on('pointerup', function() {

            if (self.isOnTop()) {
                self.close();
                self.onClose();
            }
        }).setVisible(this.isClosable());

        this.title = TextUtils.addTextByFamily(this.scene, titleText, 0, this.getTitleY(), '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        this.add([this.window, this.xButton, this.title]);
    }

    protected preInit(): void {
        // do nothing
    }

    protected preClose(): void {
        // do nothing
    }

    protected setTitle(title: string) {
        this.title.setText(title);
    }

    protected addCloseButton(text: string, callback?: () => unknown): void {
        this.addButton(text, Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, callback, false);
    }

    protected addButton(text: string, buttonBackground: string, buttonAtlas: string | undefined, buttonIcon: string, callback?: () => unknown, disableAutoClose?:  boolean): void {
        this.addCustomButton(this.getCloseButtonX(), this.getCloseButtonY(), text, buttonBackground, buttonAtlas, buttonIcon, callback, disableAutoClose);
    }

    protected addCustomButton(x: number, y: number, text: string, buttonBackground: string,
                              buttonAtlas: string | undefined, buttonIcon: string | undefined,
                              callback?: () => unknown, disableAutoClose?: boolean): Container {
        let okButton = new SquareButton(this.scene, x, y, 0, buttonBackground,
            buttonAtlas, buttonIcon, text.toLocaleUpperCase(), false);

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                if (callback != null) {
                    callback();
                }
                if (!disableAutoClose) {
                    this.closeWithCallback();
                }
            }
        });

        this.okButton = okButton;

        this.add(okButton);
        return okButton;
    }

    protected addDecoration(){
        //do nothing
    }

    public close(): void {
        this.preClose();
        BasePanel.stack = BasePanel.stack.filter(p => p != this);
        if (this.closeListener != null) {
            this.closeListener();
        }
        let self = this;
        if (this.scene && this.scene.scene.isActive()) {
            this.scene!.tweens.add({
                targets: this,
                alpha: 0,
                delay: 0,
                duration: 300,

                onComplete() {
                    self.setVisible(false);
                    self.destroy();
                }
            });
        } else {
            self.setVisible(false);
            self.destroy();
        }
    }

    public closeWithoutAnimation(): void {
        this.preClose();
        BasePanel.stack = BasePanel.stack.filter(p => p != this);
        if (this.closeListener != null) {
            this.closeListener();
        }
        let self = this;
        self.setVisible(false);
        self.destroy();
    }

    protected isClosable(): boolean {
        return true;
    }

    protected onClose(): void {
        if (this.onCloseCallback) {
            this.onCloseCallback();
        }
    }

    protected closeWithCallback() {
        this.onClose();
        this.close();
    }

    protected setOnCLoseCallback(callback: () => void) {
        this.onCloseCallback = callback;
    }

    protected abstract getWindowKey(): string;
    protected abstract getXButtonY(): number;
    protected abstract getXButtonX(): number;
    protected abstract getTitleY(): number;
    protected abstract getCloseButtonY(): number;
    protected abstract getCloseButtonX(): number;

    protected getWindowScaleX(): number {
        return 1.0;
    };

    protected getWindowScaleY(): number {
        return 1.0;
    };

    protected getWindow(){
        return this.window;
    }
}
